export const messagesPaths: any = {
  welcome: "welcome",
  "entitlement-request": "entitlementRequest",
  "request-history": "requestHistory",
  "users-reference": "usersReferences",
  approvals: "approvals",
  tasks: "tasks",
  catalog: "catalog",
  delegates: "delegates",
  entitlementReference: "entitlementsReferences",
  usersReferences: "usersReferences",
  userEntitlement: "userEntitlement",
  "emergency-users": "emergencyUsers",
  "business-roles-management": "businessRolesManagement",
  "reset-password": "resetPassword",
  "change-password": "changePassword",
  "service-request": "serviceRequest",
  "not-found": "notFound",
  "certification-reference": "certificationReference",
  "create-certification": "createCertification",
  "manuals-reference": "manuals",
  "profile-management": "profileManagement",
  report: "report",
  "temporary-abilitations": "temporaryAbilitations",
  "technical-users": "technicalUser",
  admin: "admin",
  "admin-users-management": "adminUsersManagement",
  "admin-applications-abilitations-management":
    "adminApplicationsAbilitationsManagement",
  "admin-business-role-management": "adminBRManagement",
  "admin-catalog-management": "adminCatalogManagement",
  "admin-password-management": "adminPasswordManagement",
  "admin-external-portal-management": "adminExternalPortalManagement",
  "admin-sod-management": "adminSODManagement",
  "admin-service-request-management": "adminServiceRequestManagement",
  "admin-manuals-management": "adminManualsManagement",
  "admin-report-management": "adminReportManagement",
  "admin-template-mail-management": "adminTemplateMailManagement",
  "admin-template-sms-management": "adminTemplateSmsManagement",
  "admin-workflow-management": "adminWorkflowManagement",
  "admin-tables-configuration-management": "adminTablesConfigurationManagement",
  "admin-recovery-point-management": "adminRecoveryPointManagement",
  "admin-profiles-management": "adminProfilesManagement",
  "admin-certification-configurations-management":
    "adminCertificationConfigurationsManagement",
  "external-portal": "externalPortalSection",
  "admin-audit-management": "adminAuditsManagement",
  "admin-temporary-abilitations-management":
    "adminTemporaryAbilitationsManagement",
  "admin-uigp-management": "adminUigpMgmt",
  "admin-csv-uploader": "adminCsvUploader",
  "admin-technical-users-management": "adminTechnicalUsers",
};
